import { Injectable } from '@angular/core';
import { CanActivate, Router, CanLoad } from '@angular/router';
import { GeneralService } from '../services/general.service';

@Injectable()
export class SettingsModuleGuard implements CanLoad {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canLoad() {
    if(this.gs.canAccessModule('SETTINGS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
/* General Guard Start*/
@Injectable()
export class UserROleAccessGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_SETTINGS_USER_ROLES_ACCESS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class SupervisorGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('SUPERVISOR')
    || this.gs.isAuthorized('VIEW_SETTINGS_TICKET_SUPERVISOR')
    || this.gs.isAuthorized('VIEW_SUPERVISORS')
    || this.gs.isAuthorized('VIEW_GROUP_SUPERVISORS')
    || this.gs.isAuthorized('VIEW_CUSTOMER_SERVICE_SUPERVISOR')
    || this.gs.isAuthorized('LEAD_ENRICHMENT')
    ) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class RolesGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_ROLES_CREATION')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class SubBillingGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_SETTINGS_SUBSCRIPTION_AND_BILLING')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class EmailNotificationGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('EMAIL_NOTIFICATIONS') || this.gs.isAuthorized('VIEW_NOTIFICATION_PAGE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class AnalyticsGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('ANALYTICS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class AiSettingsGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('AI_SETTINGS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class BankSetupGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('BANK_SETUP') || this.gs.isAuthorized('VIEW_BANK_SET_UP_PAGE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class ProductAndServiceGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('PRODUCT_AND_SERVICES') || this.gs.isAuthorized('VIEW_SETTINGS_PRODUCT_AND_SERVICES')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class LeadSourceGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('LEAD_SOURCE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class TwoFactorAuthGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('TWO_FACTOR_AUTHETICATION')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class IntergrationsGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('INTEGRATIONS') || this.gs.isAuthorized('VIEW_INTEGRATION_PAGE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class TicketInboundCommssGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('TICKET_INBOUND_COMMUNICATIONS') || this.gs.isAuthorized('VIEW_SETTINGS_TICKET_INBOUND_COMMS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class TicketSettingsGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('TICKETS_SETTINGS')
      || this.gs.isAuthorized('VIEW_SETTINGS_TICKET')
      || this.gs.isAuthorized('VIEW_SETTINGS_TICKET_TYPE')
      || this.gs.isAuthorized('VIEW_SLA')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class BulkMessagesGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('BULK_MESSAGES') || this.gs.isAuthorized('VIEW_SETTINGS_BULK_MESSAGES')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
/* General Guard End */

/* Workflow Guard Start */

@Injectable()
export class SalesOrderWorkflowGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('SALES_ORDER_WORKFLOW')
    || this.gs.isAuthorized('VIEW_SETTINGS_SALES_ORDER_WORKFLOW')
    || this.gs.isAuthorized('VIEW_SETTINGS_DEALS_PIPELINE_WORKFLOW')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class DealsWorkflowGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('DEALS_PIPELINE_WORKFLOW') || this.gs.isAuthorized('VIEW_SETTINGS_DEALS_PIPELINE_WORKFLOW')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class DealLostReasonGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('DEALS_LOST_REASONS') || this.gs.isAuthorized('VIEW_SETTINGS_DEALS_LOST_REASONS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class GeneralApproveWorkflowGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('GENERAL_APPROVAL_WORKFLOW')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class LeadWorkflowGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_LEAD_WORKFLOW')
    || this.gs.isAuthorized('VIEW_INVOICE_TEMPLATE')
    || this.gs.isAuthorized('VIEW_SUBSCRIPTION_TEMPLATE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
/* Workflow Guard End */

/* Templates Guard Start */
@Injectable()
export class InvQuoteTemplateGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_INVOICE_TEMPLATE')
    || this.gs.isAuthorized('VIEW_QUOTATION_TEMPLATE')
    || this.gs.isAuthorized('VIEW_QUOTATION_TEMPLATE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class ChatSMSWhatsappTemplateGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('CHAT_SMS_AND_WHATSAPP')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
@Injectable()
export class EmailSeqTemplateGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('EMAIL_SEQUENCING') || this.gs.isAuthorized('VIEW_SETTINGS')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}
/* Templates Guard End */

/* Sales Guard Start */
@Injectable()
export class SalesCompetitorGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('SALES_COMPETITION_TERRITORY') || this.gs.isAuthorized('VIEW_COMPETITION_PAGE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}

@Injectable()
export class TicketVisibilityGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_SETTINGS_TICKET_VISIBILITY') || this.gs.isAuthorized('TICKETS_TOGGLE')) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}

// @Injectable()
// export class AiSettingGuard implements CanActivate {
//   constructor(
//     private gs: GeneralService,
//     private router: Router) {}
//   canActivate() {
//     if(this.gs.isAuthorized('VIEW_SETTINGS_AI_SETTINGS')) {
//       return true
//     } else {
//       this.gs.showSpinner.next(false)
//       this.router.navigate(['/access-denied'])
//       return false
//     }
//   }
// }
/* Sales Guard End */

@Injectable()
export class KnowledgeBaseSettingsGuard implements CanActivate {
  constructor(
    private gs: GeneralService,
    private router: Router) {}
  canActivate() {
    if(this.gs.isAuthorized('VIEW_KNOWLEDGE_BASE_SETTINGS')
      || this.gs.canAccessResource('SETTINGS_TICKET')
      || this.gs.isSuperAdmin) {
      return true
    } else {
      this.gs.showSpinner.next(false)
      this.router.navigate(['/access-denied'])
      return false
    }
  }
}

export const SettingsGuard = [
  UserROleAccessGuard, SupervisorGuard, RolesGuard, EmailNotificationGuard,BankSetupGuard,
  ProductAndServiceGuard, LeadSourceGuard, IntergrationsGuard, TwoFactorAuthGuard, TicketSettingsGuard,
  TicketInboundCommssGuard, BulkMessagesGuard,SubBillingGuard,

  SalesOrderWorkflowGuard,DealsWorkflowGuard, DealLostReasonGuard, GeneralApproveWorkflowGuard, LeadWorkflowGuard,

  InvQuoteTemplateGuard,ChatSMSWhatsappTemplateGuard, EmailSeqTemplateGuard,

  SalesCompetitorGuard, TicketVisibilityGuard, KnowledgeBaseSettingsGuard
]

